<template>
    <div class="home page">
        <wrapper
            v-if="questionLoaded && questionEnough"
            v-show="gameReady"
            column
            :backgroundImage="background"
        >
            <component :is="component" @ready="gameReady = true"></component>
        </wrapper>
        <div v-if="!questionLoaded || !gameReady" class="loading">
            Loading...
        </div>
        <AlertWrapper
            v-if="error"
            title="提示"
            :content="error"
            @close="$router.go(-1)"
        />
    </div>
</template>

<script>
import {
    mapState, mapMutations, mapActions, mapGetters,
} from 'vuex';

import PageGeneral from '@/mixins/PageGeneral';
import game1 from '@/components/Stage/Game/Scenes/Game1.vue';
import game2 from '@/components/Stage/Game/Scenes/Game2.vue';
import AlertWrapper from '@/components/Wrapper/AlertWrapper.vue';

export default {
    mixins: [PageGeneral],
    components: { game1, game2, AlertWrapper },
    computed: {
        ...mapState({
            questionLoaded: (state) => !!state.questionSet.length,
            questionSetLength: (state) => state.questionSet.length,
        }),
        ...mapGetters(['isInEvent']),
        ...mapGetters({
            getGameQuestionAmount: 'config/getGameQuestionAmount',
        }),
        questionEnough() {
            const GAME = this.$route.params.type;
            const QUESTION_AMOUNT = this.getGameQuestionAmount(GAME);
            return this.questionSetLength >= QUESTION_AMOUNT;
        },
        component() {
            return this.$route.params.type;
        },
    },
    data() {
        return {
            gameReady: false,
            error: null,
        };
    },
    created() {
        this.init();
    },
    methods: {
        ...mapMutations({
            initGameData: 'initGameData',
            updateQuestion: 'updateQuestion',
        }),
        ...mapActions({
            fetchGameInformation: 'fetchGameInformation',
            fetchTower: 'fetchTower',
        }),
        async init() {
            const entity = this.isInEvent ? '活動' : '群組';
            try {
                this.initGameData();
                if (!this.isInEvent) await this.fetchTower();
                const GAME = this.$route.params.type.replace(/game/, '');
                const LEVEL = this.$route.params.level;
                await this.fetchGameInformation({ GAME, LEVEL });

                if (!this.questionLoaded) {
                    this.error = `此${entity}目前還沒有設定題庫，請稍後再試`;
                } else if (!this.questionEnough) {
                    this.error = `此${entity}題目數不足，請稍後再試`;
                }
            } catch (e) {
                this.error = e.message;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";
.loading {
    color: #ffffff;
}
</style>
